// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sT h_jq h_fq h_ft h_fF h_dM h_t","menuItemSub":"y_sV h_dT h_fq h_fF","menuMainLink":"y_sW h_jr h_hl","menuLink":"y_sX h_jr h_hl","Link":"y_rt q_rt q_qL q_q4"};